import React from "react";
import styles from "./Slide1.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Production.messages";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <div className={styles.root}>
      <h3>{formatMessage(messages.G6_P4_S1_Title)}</h3>
      <p>{formatMessage(messages.G6_P4_S1_Description)}</p>
      <block.image
        src={`${config.STATIC_ASSETS_URL}/lms/guide/guide06/en/game_audio_production_phases.svg`}
      ></block.image>
    </div>
  );
};
